import React, { useState } from "react";
import axios from "../utils/axiosConfig.js";
import { toast } from "react-toastify";
import AvailableTimesDialog from "./schedule/AvailableTimesDialog.js";
import "./CoachNew.css";
import { API_URL } from "../config/api.js";

const CoachesForm = () => {
  const [editingAvailableTimes, setEditingAvailableTimes] = useState(false);
  const [coach, setCoach] = useState({
    firstName: "",
    lastName: "",
    birthday: "",
    adress: "",
    email: "",
    phone: "",
    availableTimes: [],
    isCoachingAdult: false,
    isCoachingChildren: false,
    CoachingAdultLevels: [],
    CoachingChildrenLevels: [],
    comment: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_URL}/api/coaches`, coach); // Speichere den Trainer in der Datenbank
      toast.success("Trainer erfolgreich hinzugefügt!");

      // Resette den State auf die initialen Werte
      setCoach({
        firstName: "",
        lastName: "",
        birthday: "",
        adress: "",
        email: "",
        phone: "",
        availableTimes: [],
        isCoachingAdult: false,
        isCoachingChildren: false,
        CoachingAdultLevels: [],
        CoachingChildrenLevels: [],
        comment: "",
      });
    } catch (error) {
      console.error("Fehler:", error);
      const errorMessage = error.response?.data?.error || "Fehler beim Hinzufügen des Trainers";
      toast.error(errorMessage);
    }
  };
  const handleSaveAvailableTimes = (selectedTimes) => {
    console.log("Ausgewählte Zeiten:", selectedTimes);
    setCoach((prev) => ({
      ...prev,
      availableTimes: selectedTimes,
    }));
    setEditingAvailableTimes(false);
  };
  console.log("Coach vor Dialog:", coach);

  return (
    <div className="student-new-container">
      <div className="student-new-header">
        <h1>➕ Neuen Trainer anlegen</h1>
      </div>

      {editingAvailableTimes && (
        <AvailableTimesDialog
          entity={coach}
          closeDialog={() => setEditingAvailableTimes(false)}
          handleSaveAvailableTimes={handleSaveAvailableTimes}
        />
      )}

      <form onSubmit={handleSubmit}>
        <div className="student-new-card">
          <div className="form-field">
            <label htmlFor="firstName">Vorname</label>
            <input
              type="string"
              placeholder="Vorname"
              value={coach.firstName}
              onChange={(e) =>
                setCoach({ ...coach, firstName: e.target.value })
              }
            />
          </div>
          <div className="form-field">
            <label htmlFor="lastName">Nachname</label>
            <input
              type="string"
              placeholder="Nachname"
              value={coach.lastName}
              onChange={(e) => setCoach({ ...coach, lastName: e.target.value })}
            />
          </div>
          <div className="form-field">
            <label htmlFor="birthday">Geburtsdatum</label>
            <input
              type="date"
              value={coach.birthday}
              onChange={(e) => setCoach({ ...coach, birthday: e.target.value })}
            />
          </div>
          <div className="form-field">
            <label htmlFor="adress">Adresse</label>
            <input
              type="string"
              placeholder="Adresse"
              value={coach.adress}
              onChange={(e) => setCoach({ ...coach, adress: e.target.value })}
            />
          </div>
          <div className="form-field">
            <label htmlFor="email">E-Mail</label>
            <input
              type="email"
              placeholder="E-Mail"
              value={coach.email}
              onChange={(e) => setCoach({ ...coach, email: e.target.value })}
            />
          </div>
          <div className="form-field">
            <label htmlFor="phone">Telefon</label>
            <input
              type="string"
              placeholder="Telefon"
              value={coach.phone}
              onChange={(e) => setCoach({ ...coach, phone: e.target.value })}
            />
          </div>
          <div className="form-field">
            <label htmlFor="availableTimes">Trainingszeiten</label>
            <button
              type="button"
              onClick={() => setEditingAvailableTimes(true)}
            >
              Trainingszeiten bearbeiten
            </button>
          </div>
          
          <div className="form-field">
            <label htmlFor="isCoachingAdult">Erwachsenen-Training</label>
            {/* Toggle-Switch: 
                - Checkbox verwaltet Boolean direkt 
                - Bei checked: "Ja", sonst "Nein" */}
            <div className="toggle-switch">
              <input
                type="checkbox"
                id="isCoachingAdult"
                name="isCoachingAdult"
                checked={coach.isCoachingAdult}
                onChange={(e) =>
                  setCoach((prev) => ({
                    ...prev,
                    isCoachingAdult: e.target.checked,
                  }))
                }
              />
              <span className="toggle-label">
                {coach.isCoachingAdult ? "Ja" : "Nein"}
              </span>
            </div>
          </div>
          <div className="form-field">
            <label htmlFor="isCoachingChildren">Kinder-Training</label>
            {/* Toggle-Switch: 
                - Checkbox verwaltet Boolean direkt 
                - Bei checked: "Ja", sonst "Nein" */}
            <div className="toggle-switch">
              <input
                type="checkbox"
                id="isCoachingChildren"
                name="isCoachingChildren"
                checked={coach.isCoachingChildren}
                onChange={(e) =>
                  setCoach((prev) => ({
                    ...prev,
                    isCoachingChildren: e.target.checked,
                  }))
                }
              />
              <span className="toggle-label">
                {coach.isCoachingChildren ? "Ja" : "Nein"}
              </span>
            </div>
          </div>
          {coach.isCoachingChildren && (
  <div
    className="form-field"
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      marginBottom: "20px",
    }}
  >
    {/* Feldlabel */}
    <label style={{ marginBottom: "0.5rem" }}>Kinder-Level</label>

    {/* Buttons „Alle auswählen“ / „Auswahl aufheben“ */}
    <div style={{ margin: "0.5rem 0", display: "flex", gap: "0.5rem" }}>
      <button
        type="button"
        onClick={() =>
          setCoach((prev) => ({
            ...prev,
            CoachingChildrenLevels: [
              "Kinderland",
              "Rot",
              "Orange",
              "Grün",
              "Gelb Hobby",
              "Gelb Team",
            ],
          }))
        }
        style={{
          padding: "4px 8px",
          fontSize: "12px",
          cursor: "pointer",
        }}
      >
        Alle auswählen
      </button>
      <button
        type="button"
        onClick={() =>
          setCoach((prev) => ({
            ...prev,
            CoachingChildrenLevels: [],
          }))
        }
        style={{
          padding: "4px 8px",
          fontSize: "12px",
          cursor: "pointer",
        }}
      >
        Auswahl aufheben
      </button>
    </div>

    {/* Eine Zeile mit allen Checkboxen */}
    <div
      style={{
        display: "flex",
        gap: "1rem",
        flexWrap: "nowrap",
        alignItems: "center",
      }}
    >
      {[
        "Kinderland",
        "Rot",
        "Orange",
        "Grün",
        "Gelb Hobby",
        "Gelb Team",
              ].map((level) => (
        <label
          key={level}
          style={{
            display: "inline-flex",
            alignItems: "center",
            whiteSpace: "nowrap",
          }}
        >
          <input
            type="checkbox"
            value={level}
            checked={coach.CoachingChildrenLevels.includes(level)}
            onChange={(e) => {
              const checked = e.target.checked;
              setCoach((prev) => ({
                ...prev,
                CoachingChildrenLevels: checked
                  ? [...prev.CoachingChildrenLevels, level]
                  : prev.CoachingChildrenLevels.filter((l) => l !== level),
              }));
            }}
            style={{ marginRight: "6px" }}
          />
          {level}
        </label>
      ))}
    </div>
  </div>
)}

          <div className="form-field">
            <label htmlFor="comment">Kommentar</label>
            <textarea
              id="comment"
              name="comment"
              value={coach.comment}
              onChange={(e) => setCoach({ ...coach, comment: e.target.value })}
            />
          </div>

          <div className="form-actions">
            <button className="btn-primary" type="submit">
              ✅ Trainer hinzufügen
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CoachesForm;
